import React from "react";
import { FiGlobe, FiPackage, FiCompass, FiZap, FiTruck, FiMap, FiMonitor, FiBookOpen } from "react-icons/fi";
import { GiHoneycomb, GiPalmTree } from "react-icons/gi";
import { FaHandshake, FaKaaba, FaBuilding, FaCity } from "react-icons/fa";

const MAP = {
    leaf: GiHoneycomb,
    date: GiPalmTree,
    box: FiPackage,
    handshake: FaHandshake,
    compass: FiCompass,
    globe: FiGlobe,
    mosque: FaKaaba,
    building: FaBuilding,
    energy: FiZap,
    transport: FiTruck,
    urban: FaCity,
    tourism: FiMap,
    digital: FiMonitor,
    education: FiBookOpen,
};

export default function SectorIcon({ name, className = "w-7 h-7" }) {
    const Icon = MAP[name] || FiGlobe;
    return <Icon className={className} />;
}
